"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductTableLabels = void 0;
var _footnotes = require("./defaults/footnotes");
var _labelGroups = require("./defaults/labelGroups");
var _productDDO = require("./defaults/productDDO");
var _CbaDDO = require("./customDDO/CbaDDO");
var _MedibankDDO = require("./customDDO/MedibankDDO");
var _PIADDO = require("./customDDO/PIADDO");
var _BWMProductDDO = require("./glm3/BWMProductDDO");
var ProductTableLabels = exports.ProductTableLabels = {
  "default": {
    footnotes: _footnotes.DefaultFootnotes,
    labelGroups: _labelGroups.DefaultLabelGroups,
    productDDO: _productDDO.DefaultProductDDO
  },
  bwm: {
    productDDO: _BWMProductDDO.BWMProductDDO
  },
  medibank: {
    productDDO: _MedibankDDO.MedibankProductDDO
  },
  cba: {
    productDDO: _CbaDDO.CBAProductDDO
  },
  pia: {
    productDDO: _PIADDO.PIAProductDDO
  }
};
var _default = exports["default"] = {
  ProductTableLabels: ProductTableLabels
};